<template>
  <div class="navbar navbar-light bg-light navbar-expand-lg">
    <router-link class="navbar-brand" to="/"><img class="home-icon" src="../assets/icWwwLogo.png" alt="home-icon"/></router-link>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <div class="navbar-nav ml-auto">
        <!-- <router-link to="#features" @click.native="scrollTo('#features')" class="nav-item nav-link nav-btn-wwaw">Features</router-link> -->
        <div class="pl-3 pr-3"></div>
        <router-link to="/terms" class="nav-item nav-link nav-btn-wwaw">Terms</router-link>
        <div class="pl-3 pr-3"></div>
        <router-link to="/privacy" class="nav-item nav-link nav-btn-wwaw">Privacy</router-link>
      </div>
    </div>
  </div>
</template>

<script>
// import firebase from 'firebase'
const TIMEOUT = 1;
export default {
  name: "navbar",
  data() {
    return {};
  },
  mounted () {
    // From testing, without a brief timeout, it won't work.
    if (this.$route.hash) {
      setTimeout(() => this.scrollTo(this.$route.hash), TIMEOUT)
    }
  },
  methods: {
    scrollTo: function (hashtag) {
      setTimeout(() => { location.href = hashtag }, TIMEOUT)
    }
  }
};
</script>

<style scoped>
.navbar {
  /*background-color: #FFFFFF !important;*/
  margin-bottom: 0px;
  padding: 16px;
  border-bottom:#d3d3d3 1px solid;
}
/*.navbar-toggler-icon{*/
  /*!*background-color:black;*!*/
/*}*/
.home-icon{
  width:50px;
}
.nav-item {
  color: #000000;
}
.nav-btn-wwaw {
  /* Rectangle 2: */
  border: 1px solid #29c4d5;
  border-radius: 18px;
  height: 33px;
  width: 95px;
  line-height: 16px;
}
.nav-btn-wwaw-ns {
  color: white;
  height: 33px;
  width: 95px;
  line-height: 16px;
}
</style>
